export class UserCreditDebitSummary {
  usedCredit: number;
  creditBlock: number;
  availableCredit: number;

  constructor() {
    this.usedCredit = 0;
    this.creditBlock = 0;
    this.availableCredit = 0;
  }
}
